import script from "./DailyDeliveredOrdersChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyDeliveredOrdersChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyDeliveredOrdersChart.vue?vue&type=style&index=0&id=06d0d889&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d0d889"]])

export default __exports__